//@author: mandy

import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { TaskSettingsComponent } from "./task.settings.component";
import { S25ToggleButtonModule } from "../../s25-toggle-button/s25.toggle.button.module";

@NgModule({
    declarations: [TaskSettingsComponent],
    imports: [CommonModule, FormsModule, S25ToggleButtonModule],
    providers: [TaskSettingsComponent],
})
export class TaskSettingsModule {
    constructor() {}
}
